var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"batch-reco pt-4"},[_c('biotrack-details-component',{attrs:{"batchData":_vm.data}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }